module.exports = __webpack_public_path__ + "img/rocas.ebd2ea0b.jpg";